import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { AddCircleOutline } from '@mui/icons-material';
import { Button, Tab, Tabs } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import { OptionsTable } from 'modules/inventoryOptions';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

import { InventoryTable } from './InventoryTable';

type InventoryTab = 'inventory' | 'options';

export const ListInventoryPage = () => {
  const history = useHistory();
  const location = useLocation();
  const account = useSelector<any, any>(state => state.account);

  const params = new URLSearchParams(location.search);
  const initialTab: InventoryTab = params.get('tab') === 'options' ? 'options' : 'inventory';
  const [tab, setTab] = useState<InventoryTab>(initialTab);

  const handleTabChange = (_event: React.SyntheticEvent, nextTab: InventoryTab) => {
    setTab(nextTab);
    history.replace(`/inventory?tab=${nextTab}`);
  };

  const actionBtn =
    tab === 'inventory' ? (
      <Button variant="contained" startIcon={<AddCircleOutline />} onClick={() => history.push('/equipment/new')}>
        Add Equipment
      </Button>
    ) : (
      <Button
        variant="contained"
        startIcon={<AddCircleOutline />}
        onClick={() => history.push('/inventory/options/new')}
      >
        Add Option
      </Button>
    );

  return (
    <PageContainer title="Inventory">
      <CardContainer
        title={
          <Tabs value={tab} onChange={handleTabChange}>
            <Tab label="Inventory" value="inventory" />
            <Tab label="Options" value="options" />
          </Tabs>
        }
        actionBtn={actionBtn}
      >
        {tab === 'inventory' ? <InventoryTable accountId={account.id} /> : <OptionsTable accountId={account.id} />}
      </CardContainer>
    </PageContainer>
  );
};
